import { MUIDataTableColumn } from "mui-datatables";
import { EComponentTypes } from "../../../Utils/Enums";
import {
  InstructorModel,
  ProductsModel,
  WorkPointModel,
} from "../../../Utils/Models";
import { Vocabulary } from "../../../Utils/Vocabulary";

// Main table columns — instructor level
export const passRateColumns = (
  workPoints: WorkPointModel[] | void,
): MUIDataTableColumn[] => [
  {
    name: "instructorName",
    label: Vocabulary.instructor,
  },
  {
    name: "theoreticalPasses",
    label: Vocabulary.theoreticalPassRate,
  },
  {
    name: "practicalPasses",
    label: Vocabulary.practicalPassRate,
  },
  {
    name: "total",
    label: Vocabulary.total,
  },
];

const renderPassedValue = (value: boolean | null | undefined) => {
  if (value === true) return Vocabulary.admitted;
  if (value === false) return Vocabulary.rejected;
  return "";
};

// Expandable columns — product level
export const passRateExpandableColumns = [
  {
    name: "productName",
    label: Vocabulary.service,
    options: {
      customBodyRender: (value: string) => (
        <span style={{ paddingLeft: 10 }}>{value}</span>
      ),
    },
  },
  {
    name: "theoreticalPasses",
    label: Vocabulary.theoreticalPassRate,
  },
  {
    name: "practicalPasses",
    label: Vocabulary.practicalPassRate,
  },
  {
    name: "total",
    label: Vocabulary.total,
  },
];

// Sub-row columns — student level
export const passRateStudentColumns = [
  {
    name: "name",
    label: Vocabulary.name,
    options: {
      customBodyRender: (value: string) => (
        <span style={{ paddingLeft: 25 }}>{value}</span>
      ),
    },
  },
  {
    name: "passedTheoreticalOnFirstAttempt",
    label: Vocabulary.theoreticalPassRate,
    options: {
      customBodyRender: (value: boolean | null | undefined) =>
        renderPassedValue(value),
    },
  },
  {
    name: "passedPracticalOnFirstAttempt",
    label: Vocabulary.practicalPassRate,
    options: {
      customBodyRender: (value: boolean | null | undefined) =>
        renderPassedValue(value),
    },
  },
  {
    name: "passedBothOnFirstAttempt",
    label: Vocabulary.total,
    options: {
      customBodyRender: (value: boolean | null | undefined) =>
        renderPassedValue(value),
    },
  },
];

export const passRateFilters = (
  products: ProductsModel[],
  instructors: InstructorModel[],
  workPoints: WorkPointModel[],
) => [
  {
    property: "productId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.service,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: products.filter((p) => !p.isCertificate),
  },
    {
    property: "instructorId",
    autocompleteFilterProperty: "instructorId",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
    otherOptions: { disableClearable: true },
  },
  {
    property: "workPointId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.workPoint,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: workPoints,
  },
];
